<template>
  <div class="label">
    <span :style="{color: color}">{{title}}</span>
    <div class="l-decorate"></div>
  </div>
</template>

<script>
export default {
  name: 'zlabel',
  props: {
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#222'
    }
  }
}
</script>

<style lang="less">
.label {
  font-size: .3rem;
  // color: @clight;
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    width: 1.15rem;
    height: .1rem;
    background-image: linear-gradient(0deg, #f87784 0%, #f2f2f2 100%);
    transform: translateY(-.1rem);
    z-index: 99;
    opacity: 0.8;
	margin-top: 5px;
  }
  
}
</style>